import {
  ANALYTICS_CUSTOMERS_GENERAL,
  ANALYTICS_CUSTOMERS_MONTH,
  ANALYTICS_CUSTOMERS_YEAR,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestAnalyticsCustomersGeneral = async (params) => {
  try {
    const response = await request.get(
      ANALYTICS_CUSTOMERS_GENERAL,
      { params },
    )

    return response.data
  } catch (error) {
    throw formatError(error)
  }
}

export const requestAnalyticsCustomersMonth = async (params) => {
  try {
    const response = await request.get(
      ANALYTICS_CUSTOMERS_MONTH,
      { params },
    )

    return response.data
  } catch (error) {
    throw formatError(error)
  }
}

export const requestAnalyticsCustomersYear = async (params) => {
  try {
    const response = await request.get(
      ANALYTICS_CUSTOMERS_YEAR,
      { params },
    )

    return response.data
  } catch (error) {
    throw formatError(error)
  }
}
